export default [{
    path: "/test",
    name: "/test",
    component: () => import("@/views/test/Test.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "测试页"
    }
  },
  {
    alias: "/",
    path: "/office",
    name: "/office",
    component: () => import("@/views/office/Office.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "办事大厅"
    }
  },
  {
    path: "/accrualBasis",
    name: "/accrualBasis",
    component: () => import("@/views/accrualBasis/AccrualBasis.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "权责清单"
    }
  },
  {
    path: "/serveCenter",
    name: "/serveCenter",
    component: () => import("@/views/serveCenter/ServeCenter.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "服务中心"
    }
  },
  {
    path: "/ServeCenterDetail",
    name: "/ServeCenterDetail",
    component: () => import("@/views/serveCenter/ServeCenterDetail.vue"),
    meta: {
      showHeader: true,
      showFooter: false,
      title: "服务详情"
    }
  },
  {
    path: "/serveEvaluate",
    name: "/serveEvaluate",
    component: () => import("@/views/serveCenter/serveEvaluate.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "好差评"
    }
  },
  {
    path: "/addAdvice",
    name: "/addAdvice",
    component: () => import("@/views/management/advice/addAdvice.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "投诉建议"
    }
  },
  {
    path: "/QAHelper",
    name: "/QAHelper",
    component: () => import("@/views/QAHelper/QAHelper.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "智能问答"
    }
  },
  {
    path: "/noticesAndFilesPagination",
    name: "/noticesAndFilesPagination",
    component: () => import("@/views/noticesAndFilesPagination/noticesAndFilesPagination.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "文件公告分页"
    }
  },
  {
    path: "/fileDetail",
    name: "/fileDetail",
    component: () => import("@/views/noticesAndFilesPagination/fileDetail.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "校内公文详情"
    }
  },
    {
        path: "/classroomQuery",
        name: "/classroomQuery",
        component: () => import("@/views/management/classroomQuery/classroomQuery.vue"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "教室查询"
        }
    },
  {
        path: "/teacherTimetable",
        name: "/teacherTimetable",
        component: () => import("@/views/overseasChinese/teacherTimetable.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "教师课表"
        }
    },
  {
        path: "/classRoomTimetable",
        name: "/classRoomTimetable",
        component: () => import("@/views/overseasChinese/classRoomTimetable.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "教室课表"
        }
    },
  {
        path: "/classTimetable",
        name: "/classTimetable",
        component: () => import("@/views/overseasChinese/classTimetable.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "班级课表"
        }
    },
  {
        path: "/MySchedule",
        name: "/MySchedule",
        component: () => import("@/views/overseasChinese/MySchedule.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "我的课表"
        }
  },
  {
        path: "/classSignRecord",
        name: "/classSignRecord",
        component: () => import("@/views/overseasChinese/classSignRecord.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "签到记录(教务科、学生科)"
        }
  },
  {
        path: "/classSignRecordBzr",
        name: "/classSignRecordBzr",
        component: () => import("@/views/overseasChinese/classSignRecordBzr.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "签到记录(班主任)"
        }
  },
  {
        path: "/teachingInquiry",
        name: "/teachingInquiry",
        component: () => import("@/views/overseasChinese/teachingEvaluation/teachingInquiry.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "教学评教"
        }
  },
  {
        path: "/evaluation",
        name: "/evaluation",
        component: () => import("@/views/overseasChinese/teachingEvaluation/evaluation/index.vue"),
        meta: {
            showHeader: true,
            showFooter: false,
            title: "教学评教"
        }
  },
  {
    path: "/notifyDetail",
    name: "/notifyDetail",
    component: () => import("@/components/management/notification/notifyDetail.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "通知详情"
    }
  },
  {
    path: "/search",
    name: "/search",
    component: () => import("@/views/search/Search.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "查询页面"
    }
  },
  {
    path: "/statistical",
    name: "/statistical",
    component: () => import("@/views/statistical/Statistical.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "统计分析"
    },
    children: [{
      path: "/statistical/all",
      name: "/statistical/all",
      component: () => import("@/views/statistical/all/All.vue"),
      meta: {
        showHeader: true,
        showMenu: true,
        title: "大厅统计"
      }
    }]
  },
  {
    path: "/mine",
    name: "/mine",
    component: () => import("@/views/mine/Mine.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "个人中心"
    },
    children: [{
        path: "/mine/userData",
        name: "/mine/userData",
        component: () => import("@/views/mine/userData/UserData.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "个人信息"
        }
      },
      {
        path: "/mine/passwordEdit",
        name: "/mine/passwordEdit",
        component: () => import("@/views/mine/passwordEdit/PasswordEdit.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "账号安全"
        }
      },
      {
        path: "/mine/message",
        name: "/mine/message",
        component: () => import("@/views/mine/message/Message.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "消息中心"
        }
      },
      {
        path: "/mine/collect",
        name: "/mine/collect",
        component: () => import("@/views/mine/collect/Collect.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "我的收藏"
        }
      },
      {
        path: "/mine/suggest",
        name: "/mine/suggest",
        component: () => import("@/views/mine/suggest/Suggest.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "我的建议"
        }
      },
      {
        path: "/mine/voiceMessage",
        name: "/mine/voiceMessage",
        component: () => import("@/views/mine/voiceMessage/VoiceMessage.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "我的留言"
        }
      },
      {
        path: "/mine/myAffair",
        name: "/mine/myAffair",
        component: () => import("@/views/mine/myAffair/myAffair.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "我的事务"
        }
      }
    ]
  },
  {
        path: "/staff",
        name: "/staff",
        component: () => import("@/views/management/staff/staffRoster.vue"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "教职工花名册"
        }
    },
  {
      path: "/jobshire",
      name: "/jobshire",
      component: () => import("@/views/management/jobsHire"),
      meta: {
          showHeader: true,
          showMenu: true,
          title: "岗位聘用查询"
      }
  },
/*  {
    path: "/grade",
    name: "/grade",
    component: () => import("@/views/management/grade"),
    meta: {
        showHeader: true,
        showMenu: true,
        title: "学期成绩统计查询"
    }
},*/
    {
        path: "/grade",
        name: "/grade",
        component: () => import("@/views/overseasChinese/grade"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "学期成绩统计查询"
        }
    },
  {
      path: "/annualappraisal",
      name: "/annualappraisal",
      component: () => import("@/views/management/annualAppraisal"),
      meta: {
          showHeader: true,
          showMenu: true,
          title: "年度考核评选结果查询"
      }
  },
  {
        path: "/wage",
        name: "/wage",
        component: () => import("@/views/management/wage/wageSearch.vue"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "工资查询"
        }
    },
    {
        path: "/SupplementaryApproval",
        name: "/SupplementaryApproval",
        component: () => import("@/views/overseasChinese/SupplementaryApproval.vue"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "课堂考勤补签审批"
        }
    },
    {
        path: "/SupplementaryApprovalTeacher",
        name: "/SupplementaryApprovalTeacher",
        component: () => import("@/views/overseasChinese/SupplementaryApprovalTeacher.vue"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "课堂考勤补签审批(老师)"
        }
    },
    {
        path: "/checkInRecord",
        name: "/checkInRecord",
        component: () => import("@/views/overseasChinese/checkInRecord.vue"),
        meta: {
            showHeader: true,
            showMenu: true,
            title: "签到记录"
        }
    },
  {
    path: "/management",
    name: "/management",
    component: () => import("@/views/management/Management.vue"),
    meta: {
      showHeader: true,
      showFooter: true,
      title: "管理中心"
    },
    children: [
      {
        path: "/management/serve",
        name: "/management/serve",
        component: () => import("@/views/management/serve/Serve.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "服务管理"
        }
      },
      {
        path: "/management/label",
        name: "/management/label",
        component: () => import("@/views/management/label/Label.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "标签管理"
        }
      },
      {
        path: "/management/navlink",
        name: "/management/navlink",
        component: () => import("@/views/management/navlink/Navlink.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "导航链接"
        }
      },
      {
        path: "/management/theme",
        name: "/management/theme",
        component: () => import("@/views/management/theme/Theme.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "主题管理"
        }
      },
      {
        path: "/management/thirdPartyManagement",
        name: "/management/thirdPartyManagement",
        component: () => import("@/views/management/thirdPartyManagement/thirdPartyManagement.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "第三方管理"
        }
      },
      {
        path: "/management/special",
        name: "/management/special",
        component: () => import("@/views/management/special/Special.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "专题管理"
        }
      },
      {
        path: "/management/rightsli",
        name: "/management/rightsli",
        component: () => import("@/views/management/rightsli/Rightsli.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "权责管理"
        }
      },
      {
        path: "/management/notification",
        name: "/management/notification",
        component: () => import("@/views/management/notification/Notification.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "通知公告"
        }
      },
      {
        path: "/management/advices",
        name: "/management/advices",
        component: () => import("@/views/management/advice/Advices.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "留言建议"
        }
      },
      {
        path: "/management/user",
        name: "/management/user",
        component: () => import("@/views/management/user/User.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "账号管理"
        }
      },
      {
        path: "/management/score",
        name: "/management/score",
        component: () => import("@/views/management/score/score.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "好差评分析"
        }
      },
      {
        path: "/management/reportManage",
        name: "/management/reportManage",
        component: () => import("@/views/management/reportManage/reportManage.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "填报管理"
        }
      },
      {
        path: "/management/depManage",
        name: "/management/depManage",
        component: () => import("@/views/management/depManage/depManage.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "组织管理"
        }
      },
      {
        path: "/management/dictManage",
        name: "/management/dictManage",
        component: () => import("@/views/management/dictManage/dictManage.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "字典管理"
        }
      },
      {
        path: '/management/operationLog',
        name: '/management/operationLog',
        component: () => import('@/views/management/operationLog/operationLog.vue'),
        meta: {
          showHeader: true,
          showMenu: true,
          title: '操作日志'
        }
      },
      {
        path: "/management/flow",
        name: "/management/flow",
        component: () => import("@/views/management/flow/Flow.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "流程时效"
        }
      },
      {
        path: "/management/roleManage",
        name: "/management/roleManage",
        component: () => import("@/views/management/roleManage/roleManage.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "角色管理"
        }
      },
      {
        path: "/management/QAHelper",
        name: "/management/QAHelper",
        component: () => import("@/views/management/QAHelper/QAHelper.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "问答助手设置"
        }
      },
      {
        path: "/management/policyFile",
        name: "/management/policyFile",
        component: () => import("@/views/management/policyFile/policyFile.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "校内公文"
        }
      },
      {
        path: "/management/showcase",
        name: "/management/showcase",
        component: () => import("@/views/management/showcase/showcase.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "展示方案"
        }
      },
      {
        path: "/management/job",
        name: "/management/job",
        component: () => import("@/views/management/job/Job.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "岗位管理"
        }
      },
      {
        path: "/management/desktop",
        name: "/management/desktop",
        component: () => import("@/views/management/desktop/Desktop.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "门户桌面"
        }
      },
      {
        path: "/management/homeCard",
        name: "/management/homeCard",
        component: () => import("@/views/management/homeCard/HomeCard.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "卡片管理"
        }
      },
      {
        path: "/management/file",
        name: "/management/file",
        component: () => import("@/views/management/file/File.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "文件管理"
        }
      },
      {
        path: "/management/search",
        name: "/management/search",
        component: () => import("@/views/management/search/search.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "查询管理"
        }
      },
      {
        path: "/faceCollectApproval",
        name: "/faceCollectApproval",
        component: () => import("@/views/faceCollectApproval/faceCollectApproval.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "人脸采集审批"
        }
      },
      {
        path: "/management/systemConfig",
        name: "/management/systemConfig",
        component: () =>
          import("@/views/management/systemConfig/systemConfig.vue"),
        meta: {
          showHeader: true,
          showMenu: true,
          title: "系统参数配置",
        },
      },

    ]
  },

];